import React from 'react';
import HowInfoPane from '../home/HowInfoPane';
import ContactUs from '../common/ContactUs';
const brexhillmap = require ('../../graphics/brexhillmap.png');
// const brexhillmap = "red";

// Since this component is simple and static, there's no parent container for it.
const CheckusoutPage = () => {
  return (
    <div className="genericPageContainer grey">
      <div className="genericPageWrap">
        <header className="slp-header">
          <h5 className="slph-title">Thank you! You&apos;ve spotted one of our business cards.</h5>
          <p className="slph-subtitle">If this card were a lost, distressed or injured child, you would have just alerted their parent/carer.</p>
        </header>
        <div className="genericSettingsForm">
          <div className="genericSettingsColumn gsp-left">
            <div className="genericSettingsPanel">
              <h5 className="gsp-title">How does it work?</h5>
              <HowInfoPane inForm={true} />
            </div>

            <div className="genericSettingsPanel">
              <h5 className="gsp-title">Our Services</h5>
              <p className="gsp-body-content">Anyone can register a VizKidz account. VizKidz products are available to purchase in our <span>store</span>.</p>
              <p className="gsp-body-content">Bespoke services are available to groups, clubs and schools. These allow our products to be <span>co-branded.</span></p>
              <p className="gsp-body-content">If you’re running an event or festival, why not give us a try? We can offer a <span>commission-based</span> partnership service - we do all the hard work, your promotion brings in your commission</p>
            </div>
          </div>

          <div className="genericSettingsColumn gsp-right">
            <div className="genericSettingsPanel">
              <h5 className="gsp-title">Contact Us</h5>
              <ContactUs />
            </div>

            <div className="genericSettingsPanel nopad">
              <div className="gsp-innerpad">
                <h5 className="gsp-title">This Sighting</h5>
                <div className="gsp-input">
                  <p className="gsp-label">Time</p>
                  <input className="gsp-textinp" value="..:.." readOnly/>
                </div>
                <div className="gsp-input">
                  <p className="gsp-label">Date</p>
                  <input className="gsp-textinp" value="..." readOnly/>
                </div>

                <h6 className="gsp-subtitle">Location</h6>
              </div>
              <img className="gsp-map" width="600" height="450" src={brexhillmap} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckusoutPage;



// WEBPACK FOOTER //
// ./src/components/checkusout/CheckusoutPage.js